import PropTypes from 'prop-types';
import React from 'react';

const Counter = ({ number, text }) => {
	return (
		<>
			<span className="counter icon-circle icon-container-sm translate-middle p-1  rounded-pill bg-danger">
				{number}
				<span className="visually-hidden">{text}</span>
			</span>
		</>
	);
};

Counter.propTypes = {
	number: PropTypes.number,
	text: PropTypes.string,
};

export default Counter;
